/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { dashboardControllerGetSalesTrend } from '../fn/dashboard/dashboard-controller-get-sales-trend';
import { DashboardControllerGetSalesTrend$Params } from '../fn/dashboard/dashboard-controller-get-sales-trend';
import { dashboardControllerGetStats } from '../fn/dashboard/dashboard-controller-get-stats';
import { DashboardControllerGetStats$Params } from '../fn/dashboard/dashboard-controller-get-stats';
import { DashboardStatsDto } from '../models/dashboard-stats-dto';
import { SalesTrendItemDto } from '../models/sales-trend-item-dto';

@Injectable({ providedIn: 'root' })
export class DashboardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `dashboardControllerGetStats()` */
  static readonly DashboardControllerGetStatsPath = '/api/dashboard/stats';

  /**
   * 대시보드 통계 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardControllerGetStats()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardControllerGetStats$Response(params?: DashboardControllerGetStats$Params, context?: HttpContext): Observable<StrictHttpResponse<DashboardStatsDto>> {
    const obs = dashboardControllerGetStats(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 대시보드 통계 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardControllerGetStats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardControllerGetStats(params?: DashboardControllerGetStats$Params, context?: HttpContext): Observable<DashboardStatsDto> {
    const resp = this.dashboardControllerGetStats$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<DashboardStatsDto>): DashboardStatsDto => r.body)
    );
  }

  /** Path part for operation `dashboardControllerGetSalesTrend()` */
  static readonly DashboardControllerGetSalesTrendPath = '/api/dashboard/sales-trend';

  /**
   * 7일간 매출 추이 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dashboardControllerGetSalesTrend()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardControllerGetSalesTrend$Response(params?: DashboardControllerGetSalesTrend$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesTrendItemDto>>> {
    const obs = dashboardControllerGetSalesTrend(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 7일간 매출 추이 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `dashboardControllerGetSalesTrend$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dashboardControllerGetSalesTrend(params?: DashboardControllerGetSalesTrend$Params, context?: HttpContext): Observable<Array<SalesTrendItemDto>> {
    const resp = this.dashboardControllerGetSalesTrend$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SalesTrendItemDto>>): Array<SalesTrendItemDto> => r.body)
    );
  }

}
